export default "__VITE_ASSET__DiQsx98C__"